<template>
  <div class="container page" style="background-color: #1f1c1f">
    <van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
      <!-- <template #right>
        <span class="nav-right" @click="save()" style="color: #f3c7a2;">{{$t("setting.save")}}</span>
      </template> -->
    </van-nav-bar>
    <van-cell-group>
      <div class="c_p_j">{{ $t("setting.old_pwd") }}</div>
      <van-field
        v-model="old_password"
        :placeholder="$t('setting.old_pwd_tip')"
        type="password"
      />
      <div class="c_p_j">{{ $t("setting.new_pwd") }}</div>
      <van-field
        v-model="o_new_password"
        :placeholder="$t('setting.new_pwd_tip')"
        type="password"
      />
      <div class="c_p_j">{{ $t("setting.new_pwd1") }}</div>
      <van-field
        v-model="t_new_password"
        :placeholder="$t('setting.new_again_tip')"
        type="password"
      />
    </van-cell-group>
    <div class="sub-btn" @click="save()">
      {{ $t("q59") }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password: "",
      t_new_password: "",
      old_password: "",
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (
        this.o_new_password === "" ||
        this.o_new_password === null ||
        this.o_new_password === undefined
      ) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (
        this.t_new_password === "" ||
        this.t_new_password === null ||
        this.t_new_password === undefined
      ) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (
        this.old_password === "" ||
        this.old_password === null ||
        this.old_password === undefined
      ) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.o_new_password !== this.t_new_password) {
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      this.$http({
        method: "get",
        data: {
          old_password: this.old_password,
          new_password: this.o_new_password,
        },
        url: "user_set_loginpw",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear();
            this.$router.push("Login");
          }, 500);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.sub-btn {
  background: linear-gradient(#fde3ca, #e7b486);

  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 60px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.van-cell {
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  /deep/ .van-field__control {
    color: #f3c7a2;
  }
  &:after {
    display: none;
  }
}
.van-cell-group {
  background-color: transparent;
  &:after {
    display: none;
  }
}
.c_p_j {
  padding: 26px 30px;
  color: #f3c7a2;
  font-size: 26px;
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    margin: 0 auto;
    height: 100vh;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
  }
  .nav-bar {
    height: 50px;
  }

  /* label文字 */
  .c_p_j {
    font-size: 14px;
    padding: 18px 30px;
  }

  /* 输入框（重点优化） */
  .van-cell {
    margin: 0 30px 16px !important;
    border-radius: 10px;
    padding: 0px 15px;
    font-size: 14px;

    transition: all 0.2s;
  }

  /* 输入框hover（PC手感🔥） */
  .van-cell:hover {
    border-color: #e7b486;
    box-shadow: 0 0 10px rgba(231, 180, 134, 0.2);
  }

  /* 输入文字 */
  ::v-deep .van-field__control {
    font-size: 14px;
  }

  /* 按钮优化（重点） */
  .sub-btn {
    margin: 40px 30px;
    padding: 14px 0;
    font-size: 16px;
    border-radius: 30px;

    transition: all 0.2s;
  }

  /* 按钮hover */
  .sub-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(231, 180, 134, 0.4);
  }
}
</style>
